module.exports = __webpack_public_path__ + "static/media/exhibition_icon_play.833a9de9.svg";